import { render, staticRenderFns } from "./UnpaidOrder.vue?vue&type=template&id=0b5c1682&scoped=true"
import script from "./UnpaidOrder.vue?vue&type=script&lang=js"
export * from "./UnpaidOrder.vue?vue&type=script&lang=js"
import style0 from "./UnpaidOrder.vue?vue&type=style&index=0&id=0b5c1682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c1682",
  null
  
)

export default component.exports